/* eslint-disable no-unused-vars */
/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Table, Button, Card, Row, Col, Typography, Breadcrumb } from "antd";
import { ArrowLeftOutlined, DownloadOutlined, HomeOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import { HubCPOverviewService } from "../../../../services/api/hubCPOverviewService";

const { Title } = Typography;

const OutscanPendingInscanToCpClickableReport = () => {
    const navigate = useNavigate();
    const location = useLocation();
    // eslint-disable-next-line
    const { hubId, fromDate, toDate } = location.state || {}; // Assuming hubId is passed as currentHubId

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

    const columns = [
        {
            title: "Sr no",
            dataIndex: "srNo",
            key: "srNo",
            render: (_, __, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
            width: 80,
        },
        {
            title: "Tracking no",
            dataIndex: "trackingId",
            key: "trackingId",
            width: 150,
            render: (text) => (
                <span
                    style={{ color: "#1890ff", cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => {
                        if (text) {
                            const url = `/shipment-tracker?awb=${text}`;
                            window.open(url, "_blank");
                        }
                    }}
                >
                    {text || "-"}
                </span>
            ),
        },
        {
            title: "Outscanned date",
            dataIndex: "outscanToDestinationCpAt",
            key: "outscanToDestinationCpAt",
            width: 180,
        },
        {
            title: "CP Name",
            dataIndex: "cpName",
            key: "cpName",
            width: 200,
        },
    ];

    const fetchData = async (pageNum = 1, pageSize = 10) => {
        try {
            setLoading(true);
            const user = JSON.parse(localStorage.getItem("userinfo") || "{}");
            const userRole = user?.roles?.[0];

            let params = {
                page: pageNum - 1,
                size: pageSize,
                fromDate,
                toDate,
            };

            if (userRole !== "ROLE_CENTRALOPERATOR" && userRole !== "ROLE_HOCRM" && userRole !== "ROLE_DPCRM") {
                params.currentHubId = hubId;
            }

            const response = await HubCPOverviewService.getOutscanPendingInscanToCpClickable(params);

            if (response && response.data) {
                setData(response.data);
                setPagination(prev => ({
                    ...prev,
                    current: pageNum,
                    pageSize: pageSize,
                    total: response.count || response.totalCount || 0
                }));
            } else {
                setData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            // message.error("Failed to fetch report data");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        console.log("Effect triggered. hubId:", hubId);
        if (hubId) {
            console.log("Fetching data for hubId:", hubId);
            fetchData(pagination.current, pagination.pageSize);
        } else {
            console.warn("No hubId present, skipping fetch");
            // Fallback or handle missing hubId if necessary, maybe fetch all?
            fetchData(pagination.current, pagination.pageSize);
        }
    }, [hubId]);

    const handleTableChange = (newPagination) => {
        fetchData(newPagination.current, newPagination.pageSize);
    };

    const handleDownload = async () => {
        try {
            setDownloadLoading(true);
            const user = JSON.parse(localStorage.getItem("userinfo") || "{}");
            const userRole = user?.roles?.[0];

            let params = {};
            if (userRole !== "ROLE_CENTRALOPERATOR" && userRole !== "ROLE_HOCRM" && userRole !== "ROLE_DPCRM") {
                params.currentHubId = hubId;
            }
            params.fromDate = fromDate;
            params.toDate = toDate;

            const downloadUrl = await HubCPOverviewService.getOutscanPendingInscanToCpClickableDownload(params);
            if (downloadUrl) {
                window.open(downloadUrl, "_blank");
            } else {
                // message.error("Failed to generate download link");
            }
        } catch (error) {
            console.error("Error downloading report:", error);
            // message.error("Failed to download report");
        } finally {
            setDownloadLoading(false);
        }
    };

    return (
        <div className="hub-manager-shipment-details" style={{ padding: "20px" }}>
            <Breadcrumb separator=">">
                <Breadcrumb.Item onClick={() => navigate("/dashboard")} style={{ cursor: "pointer" }}>
                    <HomeOutlined /> Dashboard
                </Breadcrumb.Item>
                <Breadcrumb.Item onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
                    Hub Manager Overview
                </Breadcrumb.Item>
                <Breadcrumb.Item>Outscan Pending Inscan To CP</Breadcrumb.Item>
            </Breadcrumb>

            <Card style={{ marginTop: "16px" }}>
                <Row justify="space-between" align="middle" style={{ marginBottom: "16px" }}>
                    <Col>
                        <Title level={4} style={{ margin: 0 }}>
                            <Button
                                icon={<ArrowLeftOutlined />}
                                onClick={() => navigate(-1)}
                                style={{ marginRight: "16px", border: "none", background: "transparent" }}
                            />
                            Outscan Pending Inscan To Cp
                        </Title>
                    </Col>
                    <Col>
                        <Button
                            type="primary"
                            icon={<DownloadOutlined />}
                            onClick={handleDownload}
                            loading={downloadLoading}
                        >
                            Download Report
                        </Button>
                    </Col>
                </Row>

                <Table
                    columns={columns}
                    dataSource={data}
                    loading={loading}
                    pagination={{
                        ...pagination,
                        showSizeChanger: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    }}
                    onChange={handleTableChange}
                    rowKey="trackingId"
                    scroll={{ x: 1000 }}
                />
            </Card>
        </div>
    );
};

export default OutscanPendingInscanToCpClickableReport;
